import { select, call, put } from 'redux-saga/effects';
import api_v2 from 'services/api_v2';
import { currentToVenueDate } from 'utils/date';
import PromotionActions from './PromotionRedux';
import AppActions from './AppRedux';
import { AuthSelectors } from './AuthRedux';

export function* loadPromotions(actions) {
  try {
    const venueId = actions && actions.venueId;
    const token = yield select(AuthSelectors.selectToken);
    const api = api_v2(token);

    yield put(PromotionActions.setPromotionsLoading(true));

    console.log('Loading promotions', venueId);
    let resp = null;
    if (venueId) {
      const venueDetail = yield call(api.getVenue, venueId);
      console.log('>>>>>>>>>>>> venueDetail', venueDetail);

      const day = currentToVenueDate(
        new Date(),
        venueDetail.settings.hours.endOfNight
      )
        .format('ddd')
        .toLowerCase();

      resp = yield call(api.getPromotions, { venueId, day });
    } else {
      resp = yield call(api.getPromotions, {});
    }
    if (resp) yield put(PromotionActions.setPromotions(resp));
  } catch (error) {
    console.log(error);
    if (actions && !actions.silent)
      yield put(
        AppActions.setToast('There was problem loading promotions', 'danger')
      );
  } finally {
    yield put(PromotionActions.setPromotionsLoading(false));
  }
}
